import { getPreviousMonth } from '@repo/utils';

import i18n from 'constant/i18n';

export const getPreviousMonthWordByLanguage = () => {
  const isKorean = i18n.language.startsWith('ko');
  const isEnglish = i18n.language.startsWith('en');

  const currentMonth = getPreviousMonth();

  if (isKorean) {
    return currentMonth.toString();
  }
  if (isEnglish) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNames[currentMonth - 1];
  }
  return currentMonth.toString();
};
